export default {"src":"/_next/static/media/bimbel-banner.7f6b7519.svg","height":248,"width":292,"blurWidth":0,"blurHeight":0};